"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetChecks = exports.checkMoveFailed = exports.checkMoveSuccess = exports.checkMoveRequest = exports.checkCopyFailed = exports.checkCopySuccess = exports.checkCopyRequest = void 0;
const ActionTypes = require("../../actionTypes/folders/permissionChecks");
const checkCopyRequest = (projectId, folderUuid) => ({
    type: ActionTypes.CHECK_COPY_REQUEST,
    payload: {
        projectId,
        folderUuid
    }
});
exports.checkCopyRequest = checkCopyRequest;
const checkCopySuccess = (content) => ({
    type: ActionTypes.CHECK_COPY_SUCCESS,
    payload: {
        content
    }
});
exports.checkCopySuccess = checkCopySuccess;
const checkCopyFailed = (error, identifier) => ({
    type: ActionTypes.CHECK_COPY_FAILED,
    payload: {
        error,
        identifier
    }
});
exports.checkCopyFailed = checkCopyFailed;
const checkMoveRequest = (projectId, folderUuid, currentFolder) => ({
    type: ActionTypes.CHECK_MOVE_REQUEST,
    payload: {
        projectId,
        folderUuid,
        currentFolder
    }
});
exports.checkMoveRequest = checkMoveRequest;
const checkMoveSuccess = (success, resources, reasons) => ({
    type: ActionTypes.CHECK_MOVE_SUCCESS,
    payload: {
        success,
        resources,
        reasons
    }
});
exports.checkMoveSuccess = checkMoveSuccess;
const checkMoveFailed = (error) => ({
    type: ActionTypes.CHECK_MOVE_FAILED,
    payload: error
});
exports.checkMoveFailed = checkMoveFailed;
const resetChecks = () => ({
    type: ActionTypes.RESET_CHECKS
});
exports.resetChecks = resetChecks;
//# sourceMappingURL=permissionChecks.js.map